import { Objective } from "./CryoTypes";

export const isComplete = (objective: Objective, tracker: { [k: string]: boolean }) =>
  !objective.requirements.some((requirement: any) => !tracker[requirement]);
